
import Vue from 'vue';
import { components } from '../page-items';
import carrayGroup from '../page-groups/CArrayGroup.vue';


export default Vue.extend({
  // eslint-disable-next-line
  name: 'ctabs',
  components: {
    ...components, carrayGroup
  },
  props: {
    group: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} },
    groupDisabled: { type: Boolean, default: false }
  },
  data() {
    return {
      tab: 0,
    }
  },
  computed: {
    tabItems: function(): any[] {
      return this.group.tabItems.filter((tabItem: any) => this.parent._getVisibilityStatus(tabItem.showIf))
    },
  },
  mounted() {
    this.tab = parseInt(`${this.$route.query.tab}`);
  },
  methods: {
    onTabClick: function(index: number) {
      window.history.replaceState({}, document.title, window.location.pathname + `?tab=${index}`);
    },
    resolveBracketNotation: function(formulaString: string) {
      const value = this.parent._resolveFormulaValue(formulaString);
      return value ? `(${value})` : '';
    }
  }
});
